function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9985 1.99976C6.47854 1.99976 1.99854 6.47976 1.99854 11.9998C1.99854 17.5198 6.47854 21.9998 11.9985 21.9998C17.5185 21.9998 21.9985 17.5198 21.9985 11.9998C21.9985 6.47976 17.5185 1.99976 11.9985 1.99976ZM10.9985 19.9298C7.04854 19.4398 3.99854 16.0798 3.99854 11.9998C3.99854 11.3798 4.07854 10.7898 4.20854 10.2098L8.99854 14.9998V15.9998C8.99854 17.0998 9.89854 17.9998 10.9985 17.9998V19.9298ZM17.8985 17.3898C17.6385 16.5798 16.8985 15.9998 15.9985 15.9998H14.9985V12.9998C14.9985 12.4498 14.5485 11.9998 13.9985 11.9998H7.99854V9.99976H9.99854C10.5485 9.99976 10.9985 9.54976 10.9985 8.99976V6.99976H12.9985C14.0985 6.99976 14.9985 6.09976 14.9985 4.99976V4.58976C17.9285 5.77976 19.9985 8.64976 19.9985 11.9998C19.9985 14.0798 19.1985 15.9698 17.8985 17.3898Z",
  fill: "#1A1A1A"
});

function SvgIconWeb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeb);
export default __webpack_public_path__ + "static/media/icon-web.ee129334.svg";
export { ForwardRef as ReactComponent };